<app-spinner [isBusy]="showSpinner"></app-spinner>
<app-confirm-dialog ></app-confirm-dialog>
<form-wizard
  id="createReverseAuditWizard" (onStepChanged)="onStepChanged($event)">
  <wizard-step
    [title]="'Step 1'"
    [isValid]="true"
    (onNext)="onStep1Next($event)"
    [showNext]="step1.valid">
    <div *ngIf="this.step1View=='createFromRateAudit'">
      <app-rvrs-create-from-existing
        #apprvrscreatefromexisting
        (rateAuditChosen)="rateAuditChosen($event)"></app-rvrs-create-from-existing>
    </div>
    <div *ngIf="this.step1View=='importFromRateAuditFile'">
      <app-rvrs-create-from-file
        #apprvrscreatefromfile
        (fileChosen)="rateAuditChosen($event)"></app-rvrs-create-from-file>
    </div>
    <div *ngIf="this.step1View=='manuallyBuildRateAudit'">
      <app-rvrs-create-manual
        #apprvrscreatemanual
        (dataEntered)="dataManuallyEntered($event)"></app-rvrs-create-manual>
    </div>
  </wizard-step>
  <wizard-step
    [title]="'Step 2'"
    [isValid]="true"
    (onNext)="onStep2Next($event)"
    [showNext]="true"
    [showPrev]="true">
    <app-rvrs-create-step2></app-rvrs-create-step2>
  </wizard-step>
  <wizard-step
    [title]="'Step 3'"
    [isValid]="true"
    (onComplete)="onComplete($event)"
    [showNext]="true"
    [showPrev]="true">
    <app-rvrs-create-step3></app-rvrs-create-step3>

  </wizard-step>
</form-wizard>
